import { render, staticRenderFns } from "./SorryPage.vue?vue&type=template&id=0ae3f08a&scoped=true&"
import script from "./SorryPage.vue?vue&type=script&lang=js&"
export * from "./SorryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae3f08a",
  null
  
)

export default component.exports